export interface Client {
  id: string;
  name: string;
  contactPerson: string;
  email: string;
  phone: string;
  gstin: string;
  address: string;
  city: string;
  state: string;
  pincode: string;
  paymentTerms: string;
  createdAt: string;
  updatedAt: string;
  userId: string;
  isActive?: boolean;
  defaultItems?: Array<{
    id?: string;
    inventoryItemId?: string;
    name: string;
    quantity: number;
    price: number;
  }>;
  isZeroClickEnabled?: boolean;
  zeroClickFrequency?: 'Weekly' | 'Monthly' | 'Yearly' | string;
  autoSendEmail?: boolean;
}

export const PAYMENT_TERMS = [
  'Immediate',
  '7 Days',
  '15 Days',
  '30 Days',
  '45 Days',
  '60 Days'
]; 